import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { requestStarted, requestFinished } from '~/stores/redux/common/loadingSlice';
import upgradeApi from '~/pages/Dashboard/AnalyticsBox/reports/Upgrade/upgrade.api';
import { handleThunkException } from '~/services/thunk.service';

export const fetchUpgradeDataOnInit = createAsyncThunk(
    'dashboard/upgrade/fetchUpgradeDataOnInit',
    async (params, { dispatch }) => {
        const { page, navigate } = params;
        try {
            dispatch(requestStarted());
            const res = await upgradeApi.getAll(page);
            if (res) {
                dispatch(fetchOverallData(res.data));
                dispatch(fetchIndividualData(res.data));
                dispatch(requestFinished());
            }
        } catch (error) {
            handleThunkException(error, dispatch, navigate);
        }
    },
);

export const fetchNextIndividualData = createAsyncThunk(
    'dashboard/upgrade/fetchNextIndividualData',
    async (navigate, { dispatch, getState }) => {
        try {
            dispatch(incrementPage());
            const page = getState().dashboard.upgrade.page;
            const res = await upgradeApi.getAll(page);
            if (res) {
                dispatch(fetchIndividualData(res.data));
            }
        } catch (error) {
            handleThunkException(error, dispatch, navigate);
        }
    },
);

export const upgradeSlice = createSlice({
    name: 'dashboard/upgrade',
    initialState: {
        overallData: {},
        individualData: [],
        hasMore: true,
        totalUpgrade: 0,
        page: 1,
    },
    reducers: {
        fetchOverallData(state, { payload }) {
            return {
                ...state,
                overallData: payload.overallData,
            };
        },
        fetchIndividualData(state, { payload }) {
            return {
                ...state,
                individualData: [...state.individualData, ...payload.individualData],
                totalUpgrade: payload.totalUpgrade,
            };
        },
        incrementPage(state) {
            state.page++;
        },
        setHasMore(state, { payload }) {
            state.hasMore = payload;
        },
    },
});

export const { fetchOverallData, fetchIndividualData, incrementPage, setHasMore } = upgradeSlice.actions;
